import { render, staticRenderFns } from "./HotItem.vue?vue&type=template&id=40d2c925&scoped=true"
import script from "./HotItem.vue?vue&type=script&lang=js"
export * from "./HotItem.vue?vue&type=script&lang=js"
import style0 from "./HotItem.vue?vue&type=style&index=0&id=40d2c925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2c925",
  null
  
)

export default component.exports